import { network } from 'services/network';

export const setWidgetColumns = (params) => {
    const payload = {
        columns: JSON.stringify(params.columns),
        widgetId: params.widgetId,
    };
    return network.post('api/bo/setWidgetColumns', payload).then((response) => {
        return response.data;
    });
};
